import { FormControl, InputLabel, MenuItem } from '@mui/material';
import React, { useEffect } from 'react';
import { WO2Select } from 'src/common';
import { ReportFormat } from '../store/types';
import { ActionCreatorWithPayload } from '@reduxjs/toolkit';

interface ReportFormatProps {
  format: string | undefined;
  setReportFormat: ActionCreatorWithPayload<ReportFormat>;
  hasClientEditAdminOnlyPermission: boolean;
  isDisplayOnly: boolean;
}

export const ReportFormatOption = ({
  format,
  setReportFormat,
  hasClientEditAdminOnlyPermission,
  isDisplayOnly
}: ReportFormatProps) => {
  useEffect(() => {
    if (!format) {
      setReportFormat(ReportFormat.PDF);
    }
  }, [format, setReportFormat]);

  const handleSelectOption = (format: ReportFormat) => {
    const reportFormat = format as ReportFormat;
    setReportFormat(reportFormat);
  };

  return (
    <FormControl sx={{ minWidth: 200 }}>
      <InputLabel id="format-id">Report Format</InputLabel>
      <WO2Select
        labelId="format-id"
        label="Report Format"
        onChange={(e) => { handleSelectOption(e.target.value as ReportFormat) }}
        value={format ?? ReportFormat.PDF}
        disabled={isDisplayOnly}>
        <MenuItem value={ReportFormat.PDF}>PDF</MenuItem>
        <MenuItem value={ReportFormat.Excel}>Excel</MenuItem>
        {hasClientEditAdminOnlyPermission && (
          <MenuItem value={ReportFormat.JSON}>JSON</MenuItem>
        )}
      </WO2Select>
    </FormControl>
  );
};
